// client/src/components/CreateDiscussion_public.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../services/api';

function CreateDiscussion_public({ onDiscussionCreated }) {
  const [discussionName, setDiscussionName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [theme, setTheme] = useState('');
  const [allowComments, setAllowComments] = useState(true);
  const { t } = useTranslation();
const [visibility, setVisibility] = useState('everyone');
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

  const THEME_KEYS = [
    "actualite",
    "divertissement",
    "viequotidienne",
    "vieprofessionnelle"
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (discussionName.trim() === '' || theme.trim() === '') return;
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await api.post(
        `${API_URL}/api/discussions/create`,
        {
          title: discussionName,
          description: description,
          theme: theme,
          isPublic: true,
          allowComments: allowComments,   
	visibility,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
      onDiscussionCreated(response.data);
      setDiscussionName('');
      setTheme('');
      setDescription('');
      setAllowComments(false);
    } catch (error) {
      console.error('Erreur lors de la création de la discussion', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-discussion-card">
      <h3>{t('diffusion.startdiscussion_public')}</h3>
      <form onSubmit={handleSubmit}>

        {/* Nom de la discussion */}
        <div className="form-group">
          <label>{t('diffusion.name')}</label>
          <input
            type="text"
            value={discussionName}
            onChange={(e) => setDiscussionName(e.target.value)}
            placeholder={t('diffusion.nameplaceholder')}
            required
          />
        </div>

        {/* Thème */}
        <div className="form-group">
          <label>{t('diffusion.theme')}</label>
          <select value={theme} onChange={(e) => setTheme(e.target.value)} required>
            <option value="">-- {t('diffusion.selecttheme')} --</option>
            {THEME_KEYS.map(k => (
              <option key={k} value={k}>{t(`diffusion.${k}`)}</option>
            ))}
          </select>
        </div>

        {/* Description */}
        <div className="form-group">
          <label>{t('diffusion.description')}</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder={t('diffusion.descriptionplaceholder')}
            rows={3}
          />
        </div>

        {/* ─── Autoriser les commentaires ─── */}
        <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <label style={{ marginBottom: 0, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              checked={allowComments}
              onChange={(e) => setAllowComments(e.target.checked)}
              style={{ width: '16px', height: '16px', cursor: 'pointer' }}
            />
            {t('diffusion.allowComments')}
          </label>
        </div>

{/* ─── qui peut voir ? ─── */}

<div className="form-group">
  <label>{t('diffusion.visibility', 'Qui peut voir la publication ?')}</label>
  <select 
    value={visibility} 
    onChange={e => setVisibility(e.target.value)}
  >
    <option value="everyone">
      {t('diffusion.visibility_everyone', 'Tout le monde')}
    </option>
    <option value="contacts">
      {t('diffusion.visibility_contacts', 'Mes contacts uniquement')}
    </option>
  </select>
</div>

        <button type="submit" disabled={loading}>
          {loading ? t('discussion.chargement') : t('diffusion.start_public')}
        </button>
      </form>
    </div>
  );
}

export default CreateDiscussion_public;
